import common from '@/config/common.conf'
const ctx = require.context('./modules', false, /\.js$/);
let req = {};
ctx.keys().forEach(key =>{
    req[key.slice(2, -8)] = ctx(key).default
});
let config = req[process.env.VUE_APP_TAG] || {};
export default {...common, ...config}